<script>
/**
 * Voucher meta block — two-column grid of label/value pairs. Used for
 * "Invoice No / Date / PO Ref / Place of Supply / E-Way Bill" headers.
 *
 * Pass `items` as an array; each `{label, value, span?}`. `span: 2` makes
 * the row span both columns.
 */
export default {
  name: "PrintMetaGrid",
  props: {
    items: { type: Array, default: () => [] },
    columns: { type: Number, default: 2 },
  },
};
</script>

<template>
  <dl class="print-meta-grid" :class="`cols-${columns}`">
    <div
      v-for="(item, i) in items"
      :key="i"
      class="print-meta-cell"
      :class="{ 'span-2': item.span === 2 }"
    >
      <dt class="print-meta-label">{{ item.label }}</dt>
      <dd class="print-meta-value">{{ item.value || "—" }}</dd>
    </div>
  </dl>
</template>

<style scoped>
.print-meta-grid {
  display: grid;
  gap: 1mm 4mm;
  margin: 0 0 3mm;
  font-size: var(--print-fs-sm);
}

.print-meta-grid.cols-2 { grid-template-columns: 1fr 1fr; }
.print-meta-grid.cols-3 { grid-template-columns: 1fr 1fr 1fr; }
.print-meta-grid.cols-4 { grid-template-columns: repeat(4, 1fr); }

.print-meta-cell {
  display: flex;
  gap: 2mm;
  align-items: baseline;
  border-bottom: 0.25pt solid var(--print-border);
  padding-bottom: 0.5mm;
}

.print-meta-cell.span-2 {
  grid-column: 1 / -1;
}

.print-meta-label {
  color: var(--print-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: var(--print-fs-xs);
  margin: 0;
  flex: 0 0 auto;
  min-width: 26mm;
}

.print-meta-value {
  margin: 0;
  font-weight: 500;
  flex: 1 1 auto;
}
</style>
